import { isValidValue } from '.';
import { PropertyField } from '../../../../system/field';
import { ListingData } from '../../../../system/recommendations';
import { isRecordEnabled } from './recordUtils';
import { Field, FieldsList, ListingState, ListingStateKey } from './types';

export const isExcludedSourceField = (fieldKey: string) => {
  const excludedSourceFields = [PropertyField.SCHOOL_DISTRICT_SOURCE];
  return excludedSourceFields.includes(fieldKey as PropertyField);
};

export const isReadyToImportField = (field: Field) => {
  if (field.readyToImportValues?.hasValues) {
    return true;
  }

  return false;
};

export const hasResolvedData = (field: Field, state?: ListingState) => {
  if (state) {
    const resolvedFields = state[ListingStateKey.RESOLVED_FIELDS];
    return !!resolvedFields[field.key];
  }
  return false;
};

export const shouldReviewField = (field: Field) => {
  return !!field.reviewProps?.hasConflictData;
};

export const hasNoConflictData = (field: Field) => {
  return !field.reviewProps?.hasConflictData;
};

export const isSourceField = (fieldKey: PropertyField) =>
  fieldKey?.endsWith('_SOURCE');

export const isHiddenField = (field: Field, state: ListingState) => {
  const ignoredFields = [PropertyField.COUNTY, 'FIPS_CODE'];
  const hiddenFields = state[ListingStateKey.HIDDEN_FIELDS] || {};
  const isHidden =
    isSourceField(field.key) ||
    ignoredFields.includes(field.key) ||
    hiddenFields.fromListing?.includes(field.key) ||
    hiddenFields.fromTax?.includes(field.key);

  return isHidden;
};

export const getFieldsDifference = (
  recordFields: ListingData,
  allFields: FieldsList,
) => {
  return Object.keys(recordFields).reduce((validFields: any, key) => {
    const fieldValue = recordFields[key];
    if (!allFields[key] && isValidValue(fieldValue)) {
      validFields[key] = fieldValue;
    }
    return validFields;
  }, {});
};

export const filterResolvedData = (state: ListingState) => {
  const resolvedFields = state[ListingStateKey.RESOLVED_FIELDS];
  const filteredResolvedFields = Object.keys(resolvedFields).reduce(
    (acc, key) => {
      const recordId = resolvedFields[key].recordId;
      if (isRecordEnabled(recordId, state)) {
        const { [key]: resolvedData } = resolvedFields;
        return {
          ...acc,
          [key]: {
            ...resolvedData,
          },
        };
      }

      return acc;
    },
    {},
  );

  return filteredResolvedFields;
};
